import * as CacheActions from '~app/actions/cache';
import defined from '~app/core/defined';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  cache: [],
  maxCacheSize: 50,
};

export function setMaxCacheSize(state, {maxCacheSize, destructor}) {
  let cache = [...state.cache];
  applyCacheMaxSize(cache, maxCacheSize, destructor);

  return {
    ...state,
    cache,
    maxCacheSize,
  };
}

export function cacheData(state, {key, data, destructor}) {
  // Add the new entry to the front of the cache.
  let cache = [...state.cache];
  const maxSize = state.maxCacheSize;
  cache.unshift({key, data});

  applyCacheMaxSize(cache, maxSize, destructor);

  return {
    ...state,
    cache,
  };
}

function applyCacheMaxSize(cache, maxSize, destructor) {
  // Apply the cache size limit
  if (cache.length > maxSize) {
    const removedEntries = cache.splice(maxSize, cache.length - maxSize);
    destroyEntries(removedEntries, destructor);
  }
}

export function clearCache(state, {destructor}) {
  destroyEntries(state.cache, destructor);

  return {
    ...state,
    cache: [],
  };
}

function destroyEntries(entries, destructor) {
  if (defined(destructor)) {
    entries.forEach(entry => {
      destructor(entry.data);
    });
  }
}

export function recordLruIndex(state, {index}) {
  const cache = [...state.cache];

  // Move the specified index to the front of the cache.
  const entry = cache.splice(index, 1)[0];
  cache.unshift(entry);

  return {
    ...state,
    cache,
  };
}

const ACTION_HANDLERS = {
  [CacheActions.SET_MAX_CACHE_SIZE]: setMaxCacheSize,
  [CacheActions.CACHE_DATA]: cacheData,
  [CacheActions.RECORD_LRU_INDEX]: recordLruIndex,
  [CacheActions.CLEAR_CACHE]: clearCache,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/cacheReducer.js